import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppState } from '@cbcore/NGRX/core.state';
import { selectMicrositeSessionsIsLoggedIn } from '@cbcore/NGRX/coreAuth/coreAuth.selectors';

import { Subject } from 'rxjs/internal/Subject';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import isEqual from 'lodash-es/isEqual';
import { Store } from '@ngrx/store';

let disclaimerShownThisLoad = false;

@Component({
  selector: 'app-disclaimer-component',
  templateUrl: './discalimer.html',
  standalone: true
})

export class DisclaimerComponent implements OnInit, OnDestroy {
  public isVisible: boolean = false;
  public isLoggedIn: boolean;
  public ngDestroyed$ = new Subject();

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.store.select(selectMicrositeSessionsIsLoggedIn).pipe(
      distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
      takeUntil(this.ngDestroyed$)
    ).subscribe((isLoggedIn) => {
      const wasLoggedIn = this.isLoggedIn; //get current status before updating
      this.isLoggedIn = isLoggedIn;

      if (isLoggedIn && !wasLoggedIn && !disclaimerShownThisLoad) {
        this.showDisclaimer();
      }

      if (!isLoggedIn) {
        this.isVisible = false;
      }
    });
  }

  private showDisclaimer(): void {
    disclaimerShownThisLoad = true;
    this.isVisible = true;
    
    setTimeout(() => {
      this.isVisible = false;
    }, 5000);
  }

  ngOnDestroy() {
    this.ngDestroyed$.complete();
  }
}
